import React from "react";
import { MAX_MISTAKES } from "../../../lib/constants";
import { ArrowDown, Info } from "lucide-react";
import BaseModal from "../BaseModal";
import { getEmojiTiles } from "../../../lib/game-helpers";

function InfoModal({ initiallyOpen = false }) {
  const emojiTiles = getEmojiTiles();

  return (
    <BaseModal
      title="Como Jogar"
      trigger={<Info size={16} class="ml-2" />}
      initiallyOpen={initiallyOpen}
      actionButtonText="Entendi"
      actionButtonClassName="w-full mx-4 sm:w-auto sm:px-8"
    >
      <div className="text-start px-4 pb-3 text-base">
        <p className="my-1">Encontre grupos de quatro palavras que compartilham algo em comum.</p>
        <ul className="list-disc pl-5 my-1">
          <li>Selecione 4 palavras que você acha que formam um grupo e clique em <strong>'Validar tentativa'</strong>.</li>
          <li>Se você acertar, revelaremos o grupo e você pode seguir para escolher outras 4 palavras. Se errar, você perde uma das <strong>{MAX_MISTAKES} tentativas</strong>.</li>
          <li>Se você errar mas tiver acertado 3 em 4 do grupo, vamos te avisar.</li>
        </ul>
        <h3>Exemplos de Categorias</h3>
        <ul className="list-disc pl-5 mt-0 mb-2">
          <li><strong>Peixe:</strong> Robalo, Linguado, Salmão, Truta</li>
          <li><strong>Sinônimos de sorte:</strong> Acaso, Destino, Felicidade, Sucesso</li>
        </ul>
        <p className="my-2">As categorias sempre serão mais específicas do que <strong>"PALAVRAS DE 5 LETRAS"</strong>, <strong>"NOMES"</strong> ou <strong>"VERBOS"</strong>.</p>
        <p className="my-2">Cada quebra-cabeça tem exatamente uma solução. Cuidado com palavras que parecem pertencer a múltiplas categorias!</p>
        <p className="my-2">A cada <strong>grupo</strong> é atribuída uma <strong>cor</strong>, que será revelada conforme você resolve:</p>
        <div className="relative w-fit">
          {emojiTiles.map((emoji, index) => (
            <div key={index} className="flex items-center space-x-2">
              <span>{emoji}</span>
              <span>{index === 0 ? 'Fácil' : index === emojiTiles.length - 1 ? 'Difícil' : ''}</span>
            </div>
          ))}
          <ArrowDown size={20} className="absolute top-1/2 right-3 -translate-y-1/2" />
        </div>
      </div>
    </BaseModal>
  );
}

export default InfoModal;
